// extracted by mini-css-extract-plugin
module.exports = {"menu-color":"#515a6e","menu-color-active":"#409eff","menu-background":"#fff","themeColor":"#409eff","appMaineight":"calc( 100vh - 60px - 55px - 20px - 20px )"};